import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { StytchProvider } from '@stytch/react'
import { StytchUIClient } from '@stytch/vanilla-js'
import { AuthProvider } from './Auth'

const STYTCH_PUBLIC_TOKEN =
  'public-token-test-b0fbe993-679a-46ea-a5f3-5ab8fc347415'
const stytch = new StytchUIClient(STYTCH_PUBLIC_TOKEN)

ReactDOM.render(
  <React.StrictMode>
    <StytchProvider stytch={stytch}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </StytchProvider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
